import { render, staticRenderFns } from "./LearningRequestTable.vue?vue&type=template&id=93c19980&"
import script from "./LearningRequestTable.vue?vue&type=script&lang=ts&"
export * from "./LearningRequestTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports